import React from "react";

/**
 * Custom hook to show a "Processing request..." spinner overlay
 * Returns `null` if `isFetching` is false.
 */
export function useProcessingOverlay(isFetching: boolean) {
    if (!isFetching) {
        return null;
    }

    return (
        <div
            className="
        fixed
        inset-0
        flex flex-col items-center justify-center
        bg-black/50
        z-[9999]
      "
        >
            <h2 className="text-xl font-semibold mb-4 text-white">
                Processing request...
            </h2>
            <div
                className="
          animate-spin
          rounded-full
          h-12 w-12
          border-4 border-gray-300
          border-t-blue-500
        "
            />
        </div>
    );
}
